import { useAppDispatch } from '../../../redux/hooks';
import TicTacToeModal from './ticTacToeModal';
import ConnectFourModal from './connectFourModal';
import BattleshipModal from './battleshipModal';
import useGameParrot from '../../../hooks/useGameParrot';
import ChallengeModal from './challengeModal';
import {
  setBattleshipModalOpen,
  setChallengeModalOpen,
  setConnectFourModalOpen,
  setTicTacToeModalOpen,
} from '../../../redux/slices/gameParrotSlice';

/**
 * GameParrot component renders a game parrot game.
 */
const GameParrot = () => {
  const dispatch = useAppDispatch();
  const {
    challengeModalOpen,
    challenged,
    ticTacToeModalOpen,
    connectFourModalOpen,
    battleshipModalOpen,
  } = useGameParrot();

  return (
    <>
      <TicTacToeModal
        open={ticTacToeModalOpen}
        closeModal={() => dispatch(setTicTacToeModalOpen(false))}
      />
      <ConnectFourModal
        open={connectFourModalOpen}
        closeModal={() => dispatch(setConnectFourModalOpen(false))}
      />
      <BattleshipModal
        open={battleshipModalOpen}
        closeModal={() => dispatch(setBattleshipModalOpen(false))}
      />
      <ChallengeModal
        open={challengeModalOpen}
        challenged={challenged}
        openTicTacToe={() => dispatch(setTicTacToeModalOpen(true))}
        openConnectFour={() => dispatch(setConnectFourModalOpen(true))}
        openBattleship={() => dispatch(setBattleshipModalOpen(true))}
        closeModal={() => dispatch(setChallengeModalOpen(false))}
      />
    </>
  );
};

export default GameParrot;
